import { SearchItem } from '../searchTypes'

export const searchItemTitleSeparator = ' › '

export function getSearchResultTitle(
  item?: SearchItem,
  prevItem?: SearchItem,
  standalone?: boolean
) {
  let depth = 0
  let title = item?.title || ''

  if (standalone) {
    const itemParts = title.split(searchItemTitleSeparator)
    title = itemParts[itemParts.length - 1]
  } else if (item && prevItem) {
    const itemParts = item.title.split(searchItemTitleSeparator)
    const prevItemParts = prevItem.title.split(searchItemTitleSeparator)
    for (
      let i = 0;
      i < prevItemParts.length &&
      i < itemParts.length - 1 &&
      prevItemParts[i] === itemParts[i];
      i++
    ) {
      depth++
      title = title.substring(
        itemParts[i].length + searchItemTitleSeparator.length
      )
    }
  }

  return { title, depth }
}

// A filtered list (#123 recette) may miss a result's parents: "My roles" shows
// two roles of FabCOM without FabCOM itself. Indent a result only under the
// ancestors actually listed in its group, so siblings stay aligned; the title
// drops the breadcrumb of the deepest listed ancestor.
export function getScopedTreeTitle(item: SearchItem, groupTitles: Set<string>) {
  const parts = item.title.split(searchItemTitleSeparator)
  let depth = 0
  let cut = 0
  for (let i = 1; i < parts.length; i++) {
    if (groupTitles.has(parts.slice(0, i).join(searchItemTitleSeparator))) {
      depth++
      cut = i
    }
  }
  return { title: parts.slice(cut).join(searchItemTitleSeparator), depth }
}

// The tree of each group of a partitioned list: the groups are the runs of
// results between separator rows, since "Elsewhere in the organisation" is a
// list of its own.
export function getScopedTreeTitles(items: SearchItem[]) {
  const trees: Array<{ title: string; depth: number } | undefined> = []
  let start = 0
  for (let end = 0; end <= items.length; end++) {
    if (end < items.length && !items[end].isSeparator) continue
    const group = items.slice(start, end)
    const titles = new Set(group.map((item) => item.title))
    group.forEach((item) => trees.push(getScopedTreeTitle(item, titles)))
    if (end < items.length) trees.push(undefined)
    start = end + 1
  }
  return trees
}
